// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2aeiK","productName":"Table_productName__39ZZc"};